import React from "react";
import { ArrowRight, CalendarBlank } from "@phosphor-icons/react";
import { DASHBOARD } from "@/constants/testIds";

export const AnnualReport = ({ report }) => {
    if (!report) return null;
    return (
        <section
            data-testid={DASHBOARD.annualReport}
            className="relative overflow-hidden rounded-lg border border-[#1f1f22] bg-gradient-to-br from-[#0b0f05] via-[#080808] to-[#050b0d] p-6 sm:p-8 lg:p-10"
        >
            <div className="absolute -top-16 right-0 h-64 w-64 rounded-full bg-[#a3e635]/10 blur-3xl" />
            <div className="relative grid grid-cols-1 gap-6 sm:gap-8 lg:grid-cols-[1.4fr_1fr] lg:items-center">
                <div>
                    <span className="eviq-chip">
                        <CalendarBlank size={12} color="#a3e635" weight="fill" />
                        Arrives {new Date(report.ready_on).toLocaleDateString(undefined, {
                            month: "long",
                            day: "numeric",
                            year: "numeric",
                        })}
                    </span>
                    <h2 className="mt-4 font-editorial text-2xl leading-tight text-white sm:text-3xl md:text-4xl lg:text-5xl">
                        {report.headline}
                    </h2>
                    <p className="mt-4 max-w-xl text-sm text-zinc-400 lg:text-base">
                        Each January, every EVIQ member receives a personalized summary of battery
                        health, resource savings, and the community projects their membership helped
                        power.
                    </p>
                    <button
                        type="button"
                        className="mt-6 inline-flex items-center gap-2 rounded-full border border-[#a3e635]/40 bg-[#0a0f05] px-5 py-2.5 text-sm text-[#a3e635] transition-colors duration-200 hover:bg-[#141a09]"
                    >
                        Preview last year's report
                        <ArrowRight size={14} weight="bold" />
                    </button>
                </div>

                <div className="grid grid-cols-2 gap-3">
                    {[
                        { label: "Battery health change", value: `+${report.battery_health_change_pct}%`, tone: "text-[#a3e635]" },
                        { label: "Trees this year", value: report.trees_this_year, tone: "text-white" },
                        { label: "Ocean plastic", value: `${report.ocean_plastic_lbs_this_year} lbs`, tone: "text-white" },
                        { label: "Veteran hours funded", value: report.veteran_hours_funded, tone: "text-[#f59e0b]" },
                    ].map((m) => (
                        <div
                            key={m.label}
                            className="rounded-md border border-[#1f1f22] bg-black/50 p-4 backdrop-blur"
                        >
                            <div className="font-mono-metric text-[10px] uppercase tracking-[0.24em] text-zinc-500">
                                {m.label}
                            </div>
                            <div className={`mt-2 font-mono-metric text-2xl font-bold sm:text-3xl ${m.tone}`}>
                                {m.value}
                            </div>
                        </div>
                    ))}
                    <div className="col-span-2 rounded-md border border-[#1f1f22] bg-black/50 p-4 backdrop-blur">
                        <div className="font-mono-metric text-[10px] uppercase tracking-[0.24em] text-zinc-500">
                            Highlight
                        </div>
                        <p className="mt-2 font-editorial text-lg italic leading-snug text-zinc-200">
                            "{report.highlight}"
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AnnualReport;
